import React from 'react';
import cn from 'classnames';
import { Button } from '@ebsco-ui/ebsco-ui';

var CopyClipboard = function CopyClipboard(_ref) {
  var copiedToClipboardFormattedMessage = _ref.copiedToClipboardFormattedMessage,
    copyToClipboardFormattedMessage = _ref.copyToClipboardFormattedMessage,
    isDisabled = _ref.isDisabled,
    showMessage = _ref.showMessage,
    onCopy = _ref.onCopy,
    className = _ref.className;
  var messageClass = showMessage ? "nuc-copy-clipboard__message--show" : "nuc-copy-clipboard__message--hide";
  return /*#__PURE__*/React.createElement("div", {
    className: cn("nuc-copy-clipboard", className)
  }, /*#__PURE__*/React.createElement(Button, {
    className: "nuc-copy-clipboard__button",
    styleType: "inline",
    onClick: onCopy,
    disabled: isDisabled
  }, copyToClipboardFormattedMessage), /*#__PURE__*/React.createElement("div", {
    className: cn("nuc-modal-body__copy__message", "nuc-copy-clipboard__message", className ? "".concat(className, "__message") : "", messageClass),
    role: "region",
    "aria-live": "polite"
  }, copiedToClipboardFormattedMessage));
};

export { CopyClipboard as default };
//# sourceMappingURL=copy-clipboard-esm.js.map
